import { render, staticRenderFns } from "./OrgAdminAthletesCard.vue?vue&type=template&id=d89f037c&"
import script from "./OrgAdminAthletesCard.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminAthletesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports